import { useTranslation } from "react-i18next";
import { MeetingRoomInfoProps } from "./types";

import { pxToRem } from "@utils";

import { FlexCol, FlexRow, P } from "@quarks";
import { Icon } from "@atoms";
import { StyledRoomName } from "./styles";

export const MeetingRoomInfo = ({ roomName, buildingName, floorName, capacity }: MeetingRoomInfoProps) => {
  const { t } = useTranslation();

  return (
    <FlexCol
      gap={16}
      data-testid="organisms-meetingRoom_MeetingRoomInfo">
      <StyledRoomName as="h2">{roomName}</StyledRoomName>
      <P>{[buildingName, floorName].join(", ")}</P>
      <FlexRow
        justifyContent="flex-start"
        gap={8}>
        <Icon
          icon="chair"
          weight="thin"
          size={pxToRem(24)}
        />
        <P>{t("meeting:MeetingRoomSeat", { count: capacity })}</P>
      </FlexRow>
    </FlexCol>
  );
};
